import { getController } from '@/services/service'

const url = 'handoverrooms'

export const handoverRoomService = {
	...getController<
		Api.HandoverRoom,
		Api.HandoverRoomPostInput,
		Api.HandoverRoomUpdateInput
	>(url),
}
